import AbstractModule from './AbstractModule';
import { APP_NAME, $html, $document } from '../utils/environment';

const MODULE_NAME = 'Popup';
const EVENT_NAMESPACE = `${APP_NAME}.${MODULE_NAME}`;

const ClassName = {
    HAS_POPUP:  'has-pop-up-open'
};

const EVENT = {
    CLICK: `click.${EVENT_NAMESPACE}`
};


/**
 * Latest News Alerts
 */
export default class extends AbstractModule
{
    constructor (options)
    {
        super(options);

        $html.addClass(ClassName.HAS_POPUP);

        this.$el.on(EVENT.CLICK, '.js-close', (event) => this.closePopup());
    }

    closePopup() {
        $html.removeClass(ClassName.HAS_POPUP);
    }


    destroy()
    {
        $html.removeClass(ClassName.HAS_POPUP);

        this.$el.off(`.${EVENT_NAMESPACE}`);
        this.$el.remove();
    }
}
